import { twMerge } from '@belong/common';
import Icon, { ICONS } from 'components/Icon/Icon';

const SPRITE_TILE_SIZE = 96;

const SIZES = {
  40: { className: 'h-[40px] w-[40px]', scale: 40 / SPRITE_TILE_SIZE },
  60: { className: 'h-[60px] w-[60px]', scale: 60 / SPRITE_TILE_SIZE },
} as const;

type Props = {
  size: keyof typeof SIZES;
  className?: string;
};

export function RepairPlaceholder({ size, className }: Props) {
  const { className: sizeClassName, scale } = SIZES[size];

  return (
    <div className={twMerge('overflow-hidden', sizeClassName, className)}>
      <Icon icon={ICONS.REPAIR.DEFAULT} scale={scale} />
    </div>
  );
}
